class PrintPackingSlipController {
    /*@ngInject*/
    constructor($state, $stateParams, $translate, User, DateUtil) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.User = User;
        this.DateUtil = DateUtil;
        this.model = {
            shipmentDetails: [],
            shipmentData: []
        };
        this.totalAmount = 0;
        this.parentTrackingIds = [];
    }
    $onInit() {
        let printData;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;

            this.model.shipmentDetails = printData.shipmentDetails || [];
            this.model.shipmentData = printData.shipmentData || [];
            this.routeId = printData.routeId;
            this.locationId = printData.locationId;
            this.orderNo = printData.orderNo;
            this.shipmentPackedDate = printData.shipmentPackedDate;
            this.setParentTrackingId();
            this.calculateTotal();
        }
        setTimeout(() => window.print(), 1000);
    }
    setParentTrackingId() {
        this.parentTrackingIds = this.model.shipmentDetails.filter(
            d => d.isLoadTrackingId === true
        );
        this.isSingleParentTracking = this.parentTrackingIds.length === 1;
    }
    calculateTotal() {
        this.totalAmount = this.model.shipmentData.reduce((sum, s) => {
            return sum + (s.amount || 0);
        }, 0);
    }
    formatAmount(amount) {
        return amount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: amount < 1 ? 2 : 0,
            maximumFractionDigits: 2
        });
    }

}

export default PrintPackingSlipController;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_packing_slip/print_packing_slip.controller.js